module.exports = __webpack_public_path__ + "media/bootstrap-icons/border-center-1395a68f.svg";